import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=5056769c&scoped=true&"
import script from "./Markets.vue?vue&type=script&lang=ts&"
export * from "./Markets.vue?vue&type=script&lang=ts&"
import style0 from "./Markets.vue?vue&type=style&index=0&id=5056769c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056769c",
  null
  
)

export default component.exports